module.exports = __webpack_public_path__ + "img/customElm-page.53686a0d.png";